import { IconSVG } from '../types';

export const Hamburger = ({ size, style }: IconSVG) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      style={style}
      fill="none"
      viewBox="0 0 40 40"
    >
      <path
        fill="currentColor"
        d="M7.083 29.39a1.21 1.21 0 01-.89-.359 1.21 1.21 0 01-.36-.89c0-.355.12-.652.36-.891.24-.24.536-.36.89-.36h25.834c.354 0 .65.12.89.36s.36.537.36.892c0 .354-.12.65-.36.89a1.21 1.21 0 01-.89.359H7.083zm0-8.14a1.21 1.21 0 01-.89-.36 1.21 1.21 0 01-.36-.89c0-.355.12-.652.36-.891.24-.24.536-.36.89-.36h25.834c.354 0 .65.12.89.36s.36.537.36.891c0 .355-.12.652-.36.89a1.21 1.21 0 01-.89.36H7.083zm0-8.141a1.21 1.21 0 01-.89-.36 1.21 1.21 0 01-.36-.89c0-.355.12-.652.36-.891.24-.24.536-.36.89-.36h25.834c.354 0 .65.12.89.36s.36.537.36.891c0 .355-.12.652-.36.89a1.21 1.21 0 01-.89.36H7.083z"
      />
    </svg>
  );
};
